import type { Dispatch } from "redux";
import { SET_SIDE_NAV_ITEMS } from "./DashboardSideNavActionTypes";
import { ShareDashboardService, type SharedWithMeDashboard } from "./ShareDashboardService";
import { swSettings } from "app/common/services/swSettings";
const setSideNavItems = (sharedWithMeDashboards: SharedWithMeDashboard[] = [], navListLoaded = false) => {
    return {
        type: SET_SIDE_NAV_ITEMS,
        navListLoaded,
        sharedWithMeDashboards,
    };
};
export const setSharedWithMeDashboards = () => {
    return (dispatch: Dispatch) => {
        dispatch(setSideNavItems());
        const isCommonAccount = !swSettings.components.Dashboard.resources.CanViewDashboard;
        if (!isCommonAccount) {
            ShareDashboardService.getSharedWithMe()
                .then(({ dashboards }) => {
                    return dispatch(setSideNavItems(dashboards, true));
                })
                .catch(() => {
                    dispatch(setSideNavItems([], true));
                });
        } else {
            dispatch(setSideNavItems([], true));
        }
    };
};
